<ngx-spinner bdColor="#000000aa" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="true">
    <h6>Processando...</h6>
</ngx-spinner>

<div class="section">
    <div class="config-area">
        <div class="header">
            <div class="config-title">
                <div class="title-container">
                    <h3 class="title m-0">
                        <span class="label">Definições de Fluxo disponíveis</span>
                    </h3>
                </div>
            </div>
        </div>

        <hr />

        <!-- Ações -->
        <div class="actions">
            <!-- Mostrar estatísticas -->
            <button type="button" class="btn btn-outline-primary"
                    (click)="getResults()"
                    (keyDown)="getResults()"
            >
                <i class="fas fa-chart-bar mr-2"></i>
                <span>Mostrar estatísticas</span>
            </button>

            <!-- Exportar CSV -->
            <button type="button" class="btn btn-outline-primary"
                    (click)="exportCsv()"
                    (keyDown)="exportCsv()"
            >
                <i class="fas fa-file-csv mr-2"></i>
                <span>Exportar dados em formato CSV</span>
            </button>
        </div>
    </div>

    <!-- Estatísticas -->
    @if ($results() != null && $showResults()) {
        <div class="results-area">
            <hr />

            <div class="results-area-section counters mt-3">
                <dashboard-item class="w-25"
                                [_counter]="$results().countAvailableFlowDefinitions"
                                [_counterLabel]="AvailableFlowDefinitionsDescription.get('countAvailableFlowDefinitions')"
                ></dashboard-item>
                <dashboard-item class="w-25"
                                [_counter]="$results().countDistinctPatriarchs"
                                [_counterLabel]="AvailableFlowDefinitionsDescription.get('countDistinctPatriarchs')"
                ></dashboard-item>
                <dashboard-item class="w-25"
                                [_counter]="$results().countDistinctOrganizations"
                                [_counterLabel]="AvailableFlowDefinitionsDescription.get('countDistinctOrganizations')"
                ></dashboard-item>
                <dashboard-item class="w-25"
                                [_counter]="$results().countDistinctUnits"
                                [_counterLabel]="AvailableFlowDefinitionsDescription.get('countDistinctUnits')"
                ></dashboard-item>
            </div>

            <div class="results-area-section charts mt-5">
                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Patriarca</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Patriarcas"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topPatriarchs()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>

                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Órgão</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Órgãos"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topOrganizations()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
